import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "./theme";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { LicenseInfo } from "@mui/x-license";

import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./api/queryClient";
import { getRuntimeConfig } from "./runtimeConfig/runtime-config";
import { initFaro } from "./faro";
import "./index.css";
import { CssBaseline } from "@mui/material";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authconfig";

if (!getRuntimeConfig().PUBLIC_IS_TEST_ENV) {
  initFaro();
}

dayjs.extend(customParseFormat);

LicenseInfo.setLicenseKey(getRuntimeConfig().PUBLIC_MUI_LICENSE);

const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />,
    children: []
  }
]);

const rootEl = document.getElementById("root");
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <QueryClientProvider client={queryClient}>
              <CssBaseline enableColorScheme />
              <RouterProvider router={router} />
            </QueryClientProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </MsalProvider>
    </React.StrictMode>
  );
}
